export const ERROR_MESSAGES = {
    auth: {
        forgotPassword: 'FORGOT_PASSWORD_ERROR',
        getUserInfo: 'GET_USER_INFO_ERROR',
        login: 'LOGIN_ERROR',
        resetPassword: 'RESET_PASSWORD_ERROR',
        signup: 'SIGN_UP_ERROR',
        tenantNotExist: 'ERROR_TENANT_NOT_EXIST',
        tokenExpired: 'ERROR_RESET_LINK_EXPIRED',
    },
    file: {
        deleteFile: 'FILE_DELETE_ERROR',
        uploadFiles: 'FILES_UPLOAD_ERROR',
        uploadSize: 'FILE_SIZE_ERROR',
    },
    global: {
        emailAlreadyTaken: 'EMAIL_ALREADY_TAKEN',
        getCountries: 'GET_COUNTRIES_ERROR',
        getLanguages: 'GET_LANGUAGE_ERROR',
        getRelationship: 'GET_RELATIONSHIP_ERROR',
        getTranslate: 'GET_TRANSLATE_ERROR',
        wrongCompanyCode: 'WRONG_COMPANY_CODE',
    },
    home: {
        getHomeInfo: 'GET_HOME_INFO_ERROR',
    },
    newReport: {
        editMessage: 'REPORT_EDIT_MESSAGE_ERROR',
        requiredInfoNotProvided: 'REPORT_INFO_NOT_PROVIDED',
        saveNewReport: 'REPORT_SAVE_ERROR',
        sendReportMessage: 'REPORT_SEND_ERROR',
        startReport: 'REPORT_START_ERROR',
    },
    reports: {
        getCasePdf: 'GET_CASE_PDF_INCORRECT_PIN',
        getFileUrl: 'GET_FILE_URL_ERROR',
        getHomeReports: 'GET_HOME_REPORTS_ERROR',
        getReportSummary: 'GET_REPORT_SUMMARY_ERROR',
        getReports: 'GET_REPORTS_ERROR',
    },
    selects: {
        fetch: 'SOMETHING_WENT_WRONG',
    },
    settings: {
        changeCompanyCode: 'CHANGE_COMPANY_CODE_ERROR',
        changeCountry: 'CHANGE_COUNTRY_ERROR',
        changeEmail: 'CHANGE_EMAIL_ERROR',
        changeLanguage: 'CHANGE_LANGUAGE_ERROR',
        changePassword: 'CHANGE_PASSWORD_ERROR',
        changeRelationship: 'CHANGE_RELATIONSHIP_ERROR',
        getSettings: 'GET_SETTINGS_ERROR',
    },
};
